import { render, staticRenderFns } from "./EventCalendar.vue?vue&type=template&id=5ff91254&"
import script from "./EventCalendar.vue?vue&type=script&lang=js&"
export * from "./EventCalendar.vue?vue&type=script&lang=js&"
import style0 from "./EventCalendar.vue?vue&type=style&index=0&id=5ff91254&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports